<div class="app-content content ">
  <div class="content-overlay"></div>
  <div class="header-navbar-shadow"></div>
  <div class="content-wrapper">
    <div class="content-header row">
    </div>
    <div class="content-body">
      <!-- users list start -->
      <section class="app-user-list">
        <!-- users filter start -->
        <div class="card">
          <h5 class="card-header">Filtros de búsqueda</h5>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <input class="form-control" mwlFlatpickr type="text" [(ngModel)]="inicio">
              </div>
              <div class="col-md-4">
                <input class="form-control" mwlFlatpickr type="text" [(ngModel)]="fin">
              </div>
              <div class="col-md-4">
                <button class="btn btn-primary" (click)="obtenerTransacciones()">
                  <i-feather name='search' class="edit-user"></i-feather>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-datatable table-responsive pt-0">
            <div class="row m-75">
              <div class="col-lg-12 col-xl-6">
                <label>Mostrar</label>
                <select class="form-control-sm" [(ngModel)]="pageSize"
                        (change)="obtenerTransacciones()">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>

              </div>
            </div>
            <table class="user-list-table table">
              <thead class="thead-light">
              <tr>
                <th>Fecha Pedido</th>
                <th>Fecha Autorización</th>
                <th>Tienda</th>
                <th>Tipo Facturación</th>
                <th>Numero Pedido</th>
                <th>Nombres Facturación</th>
                <th>Apellidos Facturación</th>
                <th>Telefono</th>
                <th style="color: blue">Metodo Envío</th>
                <th>Estado</th>
                <th>Ver Pedido</th>
                <th>Ver guía generada</th>
                <th>Acciones</th>
              </tr>
              </thead>

              <tbody>
              <tr *ngFor="let transaccion  of listaTransacciones; let i = index">
                <td>{{ transaccion.created_at | date: 'dd-MM-yyyy' }}</td>
                <td>{{ transaccion.fechaHoraConfirmacion | date: 'dd-MM-yyyy' }}</td>
                <td [title]="transaccion.articulos[0].canal">{{ transaccion.articulos[0].canal | shorten }}</td>
                <td [title]="transaccion.tipoFacturacion">{{ transaccion.tipoFacturacion | shorten }}</td>
                <td [title]="transaccion.numeroPedido">{{ transaccion.numeroPedido | shorten }}</td>
                <td [title]="transaccion.facturacion.nombres">{{ transaccion.facturacion.nombres | shorten }}</td>
                <td [title]="transaccion.facturacion.apellidos">{{ transaccion.facturacion.apellidos | shorten }}</td>
                <td>{{ enmarcarNumeroTelefono(transaccion.facturacion.telefono) }}</td>
                <!--<td [title]="transaccion.urlMetodoPago">
                  <a *ngIf="transaccion.urlMetodoPago" [href]="transaccion.urlMetodoPago" target="_blank">Ver</a>
                </td>
                <td>
                  <a href="{{transaccion.archivoMetodoPago}}" *ngIf="transaccion.archivoMetodoPago"
                     target="_blank">
                    <i-feather name="file-text" class="mr-25"></i-feather>
                  </a>
                </td>
                <td>
                  <a href="{{transaccion.comprobanteVendedorGmb}}" *ngIf="transaccion.comprobanteVendedorGmb"
                     target="_blank">
                    <i-feather name="file-text" class="mr-25"></i-feather>
                  </a>
                </td>-->
                <td [title]="transaccion.metodoPago" style="color: blue">{{ transaccion.metodoPago | shorten }}</td>
                <td>{{ transaccion.estado }}</td>
                <td>
                  <a (click)="obtenerTransaccion(transaccion.id)" data-toggle="modal"
                     data-target="#verfactura">
                    <i-feather name="eye" class="mr-25"></i-feather>
                  </a>
                </td>
                <td>
                  <a href="{{ transaccion.guiServiEntrega }}"
                     *ngIf="transaccion.metodoPago === 'Previo Pago Servientrega Nacional' && transaccion.guiServiEntrega; else archivoGuia"
                     target="_blank">
                    <i-feather name="file-text" class="mr-25"></i-feather>
                  </a>
                  <ng-template #archivoGuia>
                    <a href="{{ transaccion.archivoGuia}}" *ngIf="transaccion.archivoGuia"
                       target="_blank">
                      <i-feather name="file-text" class="mr-25"></i-feather>
                    </a>
                  </ng-template>
                </td>
                <td>
                  <button class="btn btn-sm btn-info" *ngIf="!transaccion.verificarGeneracionGuia"
                          (click)="generarGuia(seleccionarGuiaModal, transaccion.id)"
                  >
                    Generar Guia
                  </button>
                  <button class="btn btn-primary" *ngIf="transaccion.verificarGeneracionGuia"
                          (click)="procesarEnvio(facturacionModal, transaccion)">
                    Empacar
                  </button>
                  <button class="btn btn-secondary"
                          (click)="modalMotivoDevolucion(motivoDevolucion, transaccion.id)">
                    Devolver
                  </button>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
          <ngb-pagination #paginator [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
                          [maxSize]="5 " [ellipses]="false " [boundaryLinks]="true "></ngb-pagination>

          <div class="modal fade" id="verfactura" tabindex="-1" role="dialog"
               aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl">
              <div class="modal-content">
                <form [formGroup]="notaPedido">
                  <div class="card invoice-preview-card">
                    <!-- Header starts -->
                    <div class="card-body invoice-padding pb-0">
                      <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                        <div>
                          <div class="col-12 d-block mb-2">
                            <span class="title">Fecha Pedido:</span>
                            <input type="text"
                                   class="form-control invoice-edit-input date-picker"
                                   value="{{notaPedido.controls?.created_at.value | date: 'dd-MM-yyyy'}}"
                                   disabled/>
                            <span class="title text-danger">Hora: </span>
                            <span class="text-danger">{{ horaPedido }}</span>
                          </div>
                        </div>
                        <div>
                          <div class="col-12 d-block align-items-center">
                            <span class="title">Número de pedido:</span>
                            <input type="text"
                                   class="form-control invoice-edit-input date-picker"
                                   value="{{notaPedido.controls?.numeroPedido.value}}"
                                   disabled/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Header ends -->

                    <hr class="invoice-spacing"/>

                    <!-- Address and Contact starts -->
                    <div class="card-body invoice-padding pt-0">
                      <h4 class="invoice-title mb-2">Datos para la factura</h4>
                      <div formGroupName="facturacion">
                        <div class="row">
                          <div class="col-md-3 col-12">
                            <label>Nombres</label>
                            <input class="form-control" type="text"
                                   formControlName="nombres" disabled>
                            <div *ngIf="facturacionForm.nombres.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.nombres.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Apellidos</label>
                            <input class="form-control" type="text"
                                   formControlName="apellidos" disabled>
                            <div *ngIf="facturacionForm.apellidos.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.apellidos.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Correo</label>
                            <input class="form-control" type="text"
                                   formControlName="correo" disabled>
                            <div *ngIf="facturacionForm.correo.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.correo.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <div class="form-group">
                              <label for="tipoIdentificacion">Tipo de Identificación</label>
                              <select id="tipoIdentificacion" class="form-control" formControlName="tipoIdentificacion"
                                      disabled>
                                <option value="" disabled>- Seleccione -</option>
                                <option value="cedula" selected>Cédula</option>
                                <option value="ruc">RUC</option>
                                <option value="pasaporte">Pasaporte</option>
                              </select>

                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Numero Identificación</label>
                            <input class="form-control" type="text"
                                   formControlName="identificacion"
                                   disabled
                            >
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Teléfono</label>
                            <input class="form-control" type="text"
                                   formControlName="telefono" disabled>

                          </div>
                          <div class="col-md-3 col-12">
                            <label>Pais</label>
                            <input class="form-control" type="text"
                                   formControlName="pais" disabled>
                            <div *ngIf="facturacionForm.pais.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.pais.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Provincia</label>
                            <input class="form-control" type="text"
                                   formControlName="provincia" disabled>
                            <div *ngIf="facturacionForm.provincia.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.provincia.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Ciudad</label>
                            <input class="form-control" type="text"
                                   formControlName="ciudad" disabled>
                            <div *ngIf="facturacionForm.ciudad.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.ciudad.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Calle Principal</label>
                            <input class="form-control" type="text"
                                   formControlName="callePrincipal" disabled>
                            <div *ngIf="facturacionForm.callePrincipal.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.callePrincipal.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Número</label>
                            <input class="form-control" type="text"
                                   formControlName="numero" disabled>
                            <div *ngIf="facturacionForm.numero.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.numero.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Calle Secundaria</label>
                            <input class="form-control" type="text"
                                   formControlName="calleSecundaria" disabled>
                            <div *ngIf="facturacionForm.calleSecundaria.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.calleSecundaria.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Referencia</label>
                            <input class="form-control" type="text"
                                   formControlName="referencia" disabled>
                            <div *ngIf="facturacionForm.referencia.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.referencia.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Ubicación de GPS <a href="https://www.google.com/maps/" target="_blank">Ver mapa</a>
                            </label>
                            <div class="input-group mb-3">
                              <input class="form-control" type="text" formControlName="gps"
                                     aria-describedby="basic-addon2" disabled>
                              <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon2">
                                <a href="{{notaPedido.value.facturacion?.gps}}" target="_blank"
                                   *ngIf="notaPedido.value.facturacion?.gps && notaPedido.value.facturacion?.gps.startsWith('https://'); else noGpsF">Ir</a>
                                <ng-template #noGpsF>Inválido</ng-template>
                              </span>
                              </div>
                            </div>
                            <div *ngIf="facturacionForm.gps.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.gps.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 col-12">
                      <label>Método Pago</label>
                      <input class="form-control" type="text"
                             formControlName="metodoPago" disabled>
                      <div *ngIf="notaPedidoForm.metodoPago.errors"
                           class="invalid-feedback" style="display: block;">
                        <div *ngIf="notaPedidoForm.metodoPago.errors.required">
                          Requerido
                        </div>
                      </div>
                    </div>
                    <div class="col-4 mt-2">
                      <label>Canal de pedido: </label>
                      <label> {{ notaPedido.value.canal }}</label>
                    </div>
                    <!-- Address and Contact ends -->
                    <hr class="invoice-spacing"/>
                    <!-- Product Details starts -->
                    <div class="card-body invoice-padding">
                      <div formArrayName="articulos">
                        <form class="source-item">
                          <div data-repeater-list="group-a"
                               *ngFor="let detalle of notaPedido.get('articulos')['controls']; let i = index;">
                            <ng-container [formGroup]="detalle">
                              <div class="repeater-wrapper" data-repeater-item>
                                <div class="row">
                                  <div class="col-lg-2 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2">
                                    <div class="row pl-1">
                                      <p class="card-text col-title mb-md-50 mb-0">
                                        Código
                                      </p>
                                      <input class="form-control" type="text" formControlName="codigo"
                                             disabled>

                                      <div *ngIf="detalle.controls.codigo.errors"
                                           class="invalid-feedback"
                                           style="display: block;">
                                        <div *ngIf="detalle.controls.codigo.errors.required">
                                          Requerido
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row pl-1">
                                      <p class="card-text col-title mb-md-50 mb-0">
                                        Nombre:
                                      </p>
                                      <label class="d-block text-wrap">{{ detalle.controls.articulo.value }}</label>

                                    </div>
                                  </div>
                                  <div class="col-lg-2 col-12 my-lg-0 my-2">
                                    <p class="card-text col-title mb-md-50 mb-0">
                                      Observaciones
                                    </p>
                                    <label>{{ detalle.controls.observaciones.value }}</label>

                                  </div>
                                  <div class="col-lg-1 col-12 my-lg-0 my-2">
                                    <p class="card-text col-title mb-md-50 mb-0">
                                      Cantidad
                                    </p>
                                    <input type="text" class="form-control"
                                           formControlName="cantidad"
                                           (change)="calcular()"
                                           disabled
                                    />
                                    <div *ngIf="detalle.controls.cantidad.errors"
                                         class="invalid-feedback"
                                         style="display: block;" disabled>
                                      <div *ngIf="detalle.controls.cantidad.errors.required">
                                        Requerido
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-lg-1 col-12 my-lg-0 my-2">
                                    <p class="card-text col-title mb-md-50 mb-0">
                                      Precio
                                    </p>
                                    <label>{{ detalle.controls.valorUnitario.value }}</label>
                                    <div *ngIf="detalle.controls.valorUnitario.errors"
                                         class="invalid-feedback"
                                         style="display: block;">
                                      <div *ngIf="detalle.controls.valorUnitario.errors.required">
                                        Requerido
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-lg-2 col-12 my-lg-0 my-2">
                                    <p class="card-text col-title mb-md-50 mb-0">
                                      Descuento
                                    </p>
                                    <label>{{ detalle.controls.descuento.value ? detalle.controls.descuento.value : '0' }}
                                      %</label>
                                  </div>
                                  <div class="col-lg-1 col-12 my-lg-0 my-2">
                                    <p class="card-text col-title mb-md-50 mb-0">
                                      Total
                                    </p>
                                    <label>{{ detalle.controls.precio.value }}</label>
                                    <div *ngIf="detalle.controls.precio.errors"
                                         class="invalid-feedback"
                                         style="display: block;">
                                      <div *ngIf="detalle.controls.precio.errors.required">
                                        Requerido
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-2 border-left mt-2">
                                    <img class="img-detalle"
                                         src="{{detalle.controls?.imagen_principal.value ? detalle.controls?.imagen_principal.value : './assets/images/no_existe.png'}}"
                                         *ngIf="detalle.controls?.imagen_principal" width="100px" height="100px" alt="">

                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </form>
                        <div *ngIf="notaPedidoForm.articulos.errors"
                             class="invalid-feedback" style="display: block;">
                          <div *ngIf="notaPedidoForm.articulos.errors?.required">
                            Articulos es requerido
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body invoice-padding">

                    </div>
                    <!-- Product Details ends -->
                    <hr class="invoice-spacing"/>
                    <!-- Invoice Total starts -->
                    <div class="card-body invoice-padding">
                      <div formGroupName="facturacion">
                        <div class="row mb-1 d-flex justify-content-between">
                          <div class="col-md-5 col-12">
                            <label for="codigoVendedor" class="form-label">Codigo
                              Vendedor:</label>
                            <input type="text" class="form-control" id="codigoVendedor"
                                   formControlName="codigoVendedor" disabled/>
                            <div *ngIf="facturacionForm.codigoVendedor.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.codigoVendedor.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-5 col-12">
                            <label for="nombreVendedor" class="form-label">Nombre
                              Vendedor:</label>
                            <input type="text" class="form-control" id="nombreVendedor"
                                   formControlName="nombreVendedor" disabled/>
                            <div *ngIf="facturacionForm.nombreVendedor.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="facturacionForm.nombreVendedor.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-7"></div>
                        <div class="col-md-5 text-right">
                          <div class="invoice-total-wrapper">
                            <hr class="my-50"/>
                            <div class="invoice-total-item">
                              <p class="invoice-total-title text-warning font-weight-bold">
                                Envio: {{ notaPedido.controls.nombreEnvio.value }}</p>
                              <p class="invoice-total-title text-primary font-weight-bold">
                                Total Envio: ${{ notaPedido.controls.envioTotal.value }}</p>
                            </div>
                            <hr class="my-50"/>

                            <div class="invoice-total-item">
                              <p class="invoice-total-title text-primary font-weight-bold">
                                Subtotal: ${{ notaPedido.controls.subtotal.value }}</p>
                            </div>
                            <div class="invoice-total-item">
                              <p class="invoice-total-title text-primary font-weight-bold">
                                IVA (15%): ${{ totalIva }}</p>
                            </div>
                            <div class="invoice-total-item">
                              <p class="invoice-total-title text-primary font-weight-bold">
                                Total a pagar por el cliente: ${{ notaPedido.controls.total.value }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Invoice Total ends -->

                    <hr class="invoice-spacing mt-0"/>
                    <div class="card-body invoice-padding pt-0">
                      <h2>Datos Entrega</h2>
                      <div formGroupName="envio">
                        <div class="row">
                          <div class="col-md-3 col-12">
                            <label>Nombres</label>
                            <input class="form-control" type="text"
                                   formControlName="nombres" disabled>
                            <div *ngIf="envioForm.nombres.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.nombres.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Apellidos</label>
                            <input class="form-control" type="text"
                                   formControlName="apellidos" disabled>
                            <div *ngIf="envioForm.apellidos.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.apellidos.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Correo</label>
                            <input class="form-control" type="text"
                                   formControlName="correo" disabled>
                            <div *ngIf="envioForm.correo.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.correo.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <div class="form-group">
                              <label for="tipoIdentificacionEnvio">Tipo de Identificación</label>
                              <select id="tipoIdentificacionEnvio" class="form-control"
                                      formControlName="tipoIdentificacion"
                                      disabled>
                                <option value="" disabled>- Seleccione -</option>
                                <option value="cedula" selected>Cédula</option>
                                <option value="ruc">RUC</option>
                                <option value="pasaporte">Pasaporte</option>
                              </select>

                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Numero Identificación</label>
                            <input class="form-control" type="text"
                                   formControlName="identificacion"
                                   disabled
                            >
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Teléfono</label>
                            <input class="form-control" type="text"
                                   formControlName="telefono" disabled>

                          </div>
                          <div class="col-md-3 col-12">
                            <label>Teléfono</label>
                            <input class="form-control" type="text"
                                   formControlName="telefono" disabled>
                            <div *ngIf="envioForm.telefono.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.telefono.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Pais</label>
                            <input class="form-control" type="text"
                                   formControlName="pais" disabled>
                            <div *ngIf="envioForm.pais.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.pais.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Provincia</label>
                            <input class="form-control" type="text"
                                   formControlName="provincia" disabled>
                            <div *ngIf="envioForm.provincia.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.provincia.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Ciudad</label>
                            <input class="form-control" type="text"
                                   formControlName="ciudad" disabled>
                            <div *ngIf="envioForm.ciudad.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.ciudad.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Calle Principal</label>
                            <input class="form-control" type="text"
                                   formControlName="callePrincipal" disabled>
                            <div *ngIf="envioForm.callePrincipal.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.callePrincipal.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Número</label>
                            <input class="form-control" type="text"
                                   formControlName="numero" disabled>
                            <div *ngIf="envioForm.numero.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.numero.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Calle Secundaria</label>
                            <input class="form-control" type="text"
                                   formControlName="calleSecundaria" disabled>
                            <div *ngIf="envioForm.calleSecundaria.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.calleSecundaria.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Referencia</label>
                            <input class="form-control" type="text"
                                   formControlName="referencia" disabled>
                            <div *ngIf="envioForm.referencia.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.referencia.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Ubicación de GPS <a href="https://www.google.com/maps/" target="_blank">Ver mapa</a>
                            </label>
                            <div class="input-group mb-3">
                              <input class="form-control" type="text" formControlName="gps" aria-describedby="basic-addon3" disabled>
                              <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon3">
                                <a href="{{notaPedido.value.envio?.gps}}" target="_blank" *ngIf="notaPedido.value.envio?.gps && notaPedido.value.envio?.gps.startsWith('https://'); else noGpsE">Ir</a>
                                <ng-template #noGpsE>Inválido</ng-template>
                              </span>
                              </div>
                            </div>
                            <div *ngIf="envioForm.gps.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.gps.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-12">
                            <label>Canal Envio</label>
                            <input class="form-control" type="text"
                                   formControlName="canalEnvio" disabled>
                            <div *ngIf="envioForm.canalEnvio.errors"
                                 class="invalid-feedback" style="display: block;">
                              <div *ngIf="envioForm.canalEnvio.errors.required">
                                Requerido
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row p-2">
                      <div class="col-12">
                        <button type="reset" class="btn btn-secondary"
                                data-dismiss="modal">Cerrar
                        </button>
                        <button #printButton class="btn btn-primary" type="button" (click)="imprimirEmpacado()">Imprimir
                        </button>
                      </div>
                    </div>


                  </div>
                </form>
              </div>
            </div>
          </div>
          <hr/>
        </div>
      </section>
      <!-- users list ends -->
    </div>
  </div>
</div>

<ng-template #facturacionModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Enviar</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss( 'Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="autorizarForm">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Número de guía</label>
            <input class="form-control form-control-lg" disabled formControlName="numeroGuia"/>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="basicSelect">Confirmación Empacado</label>
            <select id="basicSelect" class="form-control" formControlName="confirmacionEnvio">
              <option value="">- Seleccione -</option>
              <option value="Si">Si</option>
            </select>
            <div *ngIf="autorizarFForm.confirmacionEnvio.errors"
                 class="invalid-feedback" style="display: block;">
              <div *ngIf="autorizarFForm.confirmacionEnvio.errors.required">
                Requerido
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="numeroPedido">Ingreso Numero Pedido</label>
            <input class="form-control form-control-lg" type="text" id="numeroPedido"
                   formControlName="numeroPedido" disabled/>
            <div *ngIf="autorizarFForm.numeroPedido.errors"
                 class="invalid-feedback" style="display: block;">
              <div *ngIf="autorizarFForm.numeroPedido.errors.required">
                Requerido
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="customFile">Cargar Foto Evidencia Empacado</label>
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="customFile"
                     accept="image/png, image/gif, image/jpeg"
                     (change)="cargarArchivo($event, 'fotoEmpaque')"
                     formControlName="fotoEmpaque"/>
              <label class="custom-file-label" for="customFile" id="fotoEmpaquelbl">Selecionar
              </label>
            </div>
            <div *ngIf="autorizarFForm.fotoEmpaque.errors"
                 class="invalid-feedback" style="display: block;">
              <div *ngIf="autorizarFForm.fotoEmpaque.errors.required">
                Requerido
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="customVideo">Cargar Video Evidencia Empacado</label>
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="customVideo"
                     accept="video/mp4,video/x-m4v,video/*"
                     (change)="cargarArchivo($event, 'videoEmpaque')"
                     formControlName="videoEmpaque"/>
              <label class="custom-file-label" for="customVideo" id="videoEmpaquelbl">Selecionar
              </label>
            </div>
            <div *ngIf="autorizarFForm.videoEmpaque.errors"
                 class="invalid-feedback" style="display: block;">
              <div *ngIf="autorizarFForm.videoEmpaque.errors.required">
                Requerido
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss( 'Cross click')">Cerrar</button>
    <button type="button" class="btn btn-primary" (click)="procesarAutorizacionEnvio()"
            [ngClass]="{'loading': mostrarSpinner}" [disabled]="mostrarSpinner">
            <span *ngIf="mostrarSpinner" class="spinner-border spinner-border-sm" role="status"
                  aria-hidden="true"></span>
      Guardar
    </button>
  </div>
</ng-template>


<ng-template #seleccionarGuiaModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Enviar</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss( 'Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="notaPedido">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="generarGuia">Método de envío</label>
            <select class="form-control" id="generarGuia"
                    formControlName="metodoPago" (change)="onSelectChange($event)">
              <option value="">- Seleccione metodo de envío-</option>
              <option [value]="pago.nombre" *ngFor="let pago of listaMetodoPago">
                {{ pago.nombre }}
              </option>
            </select>
            <div *ngIf="notaPedidoForm.metodoPago.errors"
                 class="invalid-feedback" style="display: block;">
              <div *ngIf="notaPedidoForm.metodoPago.errors.required">
                Requerido
              </div>
            </div>
            <!--<select id="generarGuia" class="form-control" formControlName="generarGuia"
                    (change)="onSelectChange($event)">
              <option value="">- Seleccione -</option>
              <option [value]="item.valor" *ngFor="let item of guias">{{ item.valor }}</option>
            </select>-->
          </div>
        </div>
        <div class="col-12">
          <ng-container *ngTemplateOutlet="templatePedido"></ng-container>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('Cross click')">Cerrar</button>
    <button (click)="seleccionarGuia()" class="btn btn-primary" type="button" *ngIf="mostrarImprimirGuia"
            [ngClass]="{'loading': mostrarSpinner}" [disabled]="mostrarSpinner"
    >
      <span *ngIf="mostrarSpinner" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span>
      Imprimir
      guia
    </button>
    <button (click)="guardarGuiaServiEntrega()" class="btn btn-primary" type="button" *ngIf="mostrarDiv"
            [ngClass]="{'loading': mostrarSpinner}" [disabled]="mostrarSpinner">
      <span *ngIf="mostrarSpinner" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span>
      Guardar guía
    </button>
  </div>
</ng-template>

<ng-template #templatePedido>
  <form [formGroup]="notaPedido">
    <div class="card invoice-preview-card">
      <!-- Header starts -->
      <div class="card-body invoice-padding pb-0">
        <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
          <div>
            <div class="d-flex align-items-center mb-1">
              <span class="title mr-1">Fecha Pedido:</span>
              <input type="text"
                     class="form-control invoice-edit-input date-picker"
                     value="{{notaPedido.controls?.created_at.value | date: 'dd-MM-yyyy'}}"
                     disabled/>
            </div>
          </div>
          <div class="invoice-number-date mt-md-0 mt-2">
            <div class="d-flex align-items-center mb-1">
              <h4 class="invoice-title mr-1">Numero Pedido</h4>
              <div class="input-group input-group-merge invoice-edit-input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i-feather name="hash"
                               class="edit-user"></i-feather>
                  </div>
                </div>
                <input type="text" class="form-control invoice-edit-input"
                       placeholder="{{notaPedido.controls?.numeroPedido.value}}"
                       disabled/>
              </div>
            </div>
          </div>
          <div class="invoice-number-date mt-md-0 mt-2">
            <div class="d-flex align-items-center mb-1">
              <h4 class="invoice-title mr-1">Numero Guía</h4>
              <div class="input-group input-group-merge invoice-edit-input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i-feather name="hash"></i-feather>
                  </div>
                </div>
                <input type="text" class="form-control"
                       placeholder="{{notaPedido.controls?.numeroGuia.value}}"
                       disabled/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Header ends -->
      <!--<hr class="invoice-spacing"/>
      <div class="col-4">
        <label>Método de envío</label>
        <input class="form-control" type="text"
               formControlName="metodoPago" disabled>
        <div *ngIf="notaPedidoForm.metodoPago.errors"
             class="invalid-feedback" style="display: block;">
          <div *ngIf="notaPedidoForm.metodoPago.errors.required">
            Requerido
          </div>
        </div>
      </div>-->
      <!-- Address and Contact ends -->
      <hr class="invoice-spacing"/>
      <!-- Product Details starts -->
      <div class="card-body invoice-padding">
        <div formArrayName="articulos">
          <form class="source-item">
            <div data-repeater-list="group-a"
                 *ngFor="let detalle of notaPedido.get('articulos')['controls']; let i = index;">
              <ng-container [formGroup]="detalle">
                <div class="repeater-wrapper" data-repeater-item>
                  <div class="row">
                    <div class="col-12 d-flex product-details-border position-relative pr-0">
                      <div class="row w-100 pr-lg-0 pr-1 py-2">
                        <div class="col-lg-2 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2">
                          <p class="card-text col-title mb-md-50 mb-0">
                            Código Producto
                          </p>
                          <input class="form-control" type="text"
                                 (change)="obtenerProducto(i)"
                                 formControlName="codigo"
                                 disabled>
                          <div *ngIf="detalle.controls.codigo.errors"
                               class="invalid-feedback"
                               style="display: block;">
                            <div *ngIf="detalle.controls.codigo.errors.required">
                              Requerido
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-2 col-12 my-lg-0 my-2">
                          <p class="card-text col-title mb-md-50 mb-0">
                            Cantidad
                          </p>
                          <input type="text" class="form-control"
                                 formControlName="cantidad"
                                 (change)="calcular()"
                                 disabled
                          />
                          <div *ngIf="detalle.controls.cantidad.errors"
                               class="invalid-feedback"
                               style="display: block;" disabled>
                            <div *ngIf="detalle.controls.cantidad.errors.required">
                              Requerido
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-2 col-12 my-lg-0 my-2">
                          <p class="card-text col-title mb-md-50 mb-0">
                            Nombre
                          </p>
                          <input type="text" class="form-control"
                                 formControlName="articulo"
                                 disabled
                          />
                          <div *ngIf="detalle.controls.articulo.errors"
                               class="invalid-feedback"
                               style="display: block;">
                            <div *ngIf="detalle.controls.articulo.errors.required">
                              Requerido
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-1 col-12 my-lg-0 my-2">
                          <p class="card-text col-title mb-md-50 mb-0">
                            Precio
                          </p>
                          <label>{{ detalle.controls.valorUnitario.value }}</label>
                          <div *ngIf="detalle.controls.valorUnitario.errors"
                               class="invalid-feedback"
                               style="display: block;">
                            <div *ngIf="detalle.controls.valorUnitario.errors.required">
                              Requerido
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-2 col-12 my-lg-0 my-2">
                          <p class="card-text col-title mb-md-50 mb-0">
                            Descuento
                          </p>
                          <label>{{ detalle.controls.descuento.value }} %</label>

                        </div>
                        <div class="col-lg-1 col-12 my-lg-0 my-2">
                          <p class="card-text col-title mb-md-50 mb-0">
                            Total
                          </p>
                          <label>{{ detalle.controls.precio.value }}</label>
                          <div *ngIf="detalle.controls.precio.errors"
                               class="invalid-feedback"
                               style="display: block;">
                            <div *ngIf="detalle.controls.precio.errors.required">
                              Requerido
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2 border-left">
                          <img class="img-detalle" alt="producto"
                               src="{{detalle.controls?.imagen_principal.value ? detalle.controls?.imagen_principal.value : './assets/images/no_existe.png'}}"
                               *ngIf="detalle.controls?.imagen_principal" width="100px" height="100px">
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </form>
          <div *ngIf="notaPedidoForm.articulos.errors"
               class="invalid-feedback" style="display: block;">
            <div *ngIf="notaPedidoForm.articulos.errors?.required">
              Artciulos es requerido
            </div>
          </div>
        </div>
      </div>
      <div class="card-body invoice-padding">

      </div>
      <!-- Product Details ends -->
      <hr class="invoice-spacing"/>
      <!-- Invoice Total starts -->
      <div class="card-body invoice-padding">
        <div class="row">
          <div class="col-md-7"></div>
          <div class="col-md-5 text-right">
            <div class="invoice-total-wrapper">
              <hr class="my-50"/>
              <div class="invoice-total-item">
                <!--<p class="invoice-total-title text-warning font-weight-bold">
                  Envio: {{ notaPedido.controls.nombreEnvio.value }}</p>-->
                <p class="invoice-total-title text-primary font-weight-bold">
                  Total Envio: ${{ notaPedido.controls.envioTotal.value }}
                </p>
              </div>
              <div class="invoice-total-item">
                <h4 class="text-danger font-weight-bold">
                  Total a pagar por el cliente: ${{ notaPedido.controls.total.value }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Invoice Total ends -->

      <hr class="invoice-spacing mt-0"/>
      <div class="card-body invoice-padding pt-0">
        <h2>Datos Entrega</h2>
        <div formGroupName="envio">
          <div class="row">
            <div class="col-4">
              <label>Nombres</label>
              <input class="form-control" type="text"
                     formControlName="nombres" disabled>
              <div *ngIf="envioForm.nombres.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.nombres.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Apellidos</label>
              <input class="form-control" type="text"
                     formControlName="apellidos" disabled>
              <div *ngIf="envioForm.apellidos.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.apellidos.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Correo</label>
              <input class="form-control" type="text"
                     formControlName="correo" disabled>
              <div *ngIf="envioForm.correo.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.correo.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Numero Identificación</label>
              <input class="form-control" type="text"
                     formControlName="identificacion" disabled>
              <div *ngIf="envioForm.identificacion.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.identificacion.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Teléfono</label>
              <input class="form-control" type="text"
                     formControlName="telefono" disabled>
              <div *ngIf="envioForm.telefono.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.telefono.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Pais</label>
              <input class="form-control" type="text"
                     formControlName="pais" disabled>
              <div *ngIf="envioForm.pais.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.pais.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Provincia</label>
              <input class="form-control" type="text"
                     formControlName="provincia" disabled>
              <div *ngIf="envioForm.provincia.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.provincia.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Ciudad</label>
              <input class="form-control" type="text"
                     formControlName="ciudad" disabled>
              <div *ngIf="envioForm.ciudad.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.ciudad.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Calle Principal</label>
              <input class="form-control" type="text"
                     formControlName="callePrincipal" disabled>
              <div *ngIf="envioForm.callePrincipal.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.callePrincipal.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Número</label>
              <input class="form-control" type="text"
                     formControlName="numero" disabled>
              <div *ngIf="envioForm.numero.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.numero.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Calle Secundaria</label>
              <input class="form-control" type="text"
                     formControlName="calleSecundaria" disabled>
              <div *ngIf="envioForm.calleSecundaria.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.calleSecundaria.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Referencia</label>
              <input class="form-control" type="text"
                     formControlName="referencia" disabled>
              <div *ngIf="envioForm.referencia.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.referencia.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Ubicación de GPS <a href="https://www.google.com/maps/" target="_blank">Ver mapa</a> </label>
              <div class="input-group mb-3">
                <input class="form-control" type="text" formControlName="gps" aria-describedby="basic-addon4" disabled>
                <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon4">
                                <a href="{{notaPedido.value.envio?.gps}}" target="_blank" *ngIf="notaPedido.value.envio?.gps && notaPedido.value.envio?.gps.startsWith('https://'); else noGps">Ir</a>
                                <ng-template #noGps>Inválido</ng-template>
                              </span>
                </div>
              </div>
              <div *ngIf="envioForm.gps.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.gps.errors.required">
                  Requerido
                </div>
              </div>
            </div>
            <div class="col-4">
              <label>Canal Envio</label>
              <input class="form-control" type="text"
                     formControlName="canalEnvio" disabled>
              <div *ngIf="envioForm.canalEnvio.errors"
                   class="invalid-feedback" style="display: block;">
                <div *ngIf="envioForm.canalEnvio.errors.required">
                  Requerido
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="invoice-spacing mt-0"/>
      <div class="ml-2 mb-2" *ngIf="mostrarDiv">
        <label>Archivo Servientrega</label>
        <input class="form-control-file" type="file" (change)="onFileSelected($event)"
               formControlName="guiServiEntrega">

      </div>

    </div>
  </form>
</ng-template>


<ng-template #motivoDevolucion let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Motivo de devolución del pedido</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss( 'Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-content">
    <div class="card-body invoice-padding">
      <div class="col-12">
        <p class="bg-light-danger text-center">Por favor, ingrese el motivo por el cual usted esta devolviendo el
          pedido.</p>
      </div>
    </div>
    <form [formGroup]="motivoDevolucionPedidoForm">
      <div class="card-body invoice-padding">
        <div class="row">
          <div class="col-12">
            <label>Ingrese el motivo</label>
            <textarea class="form-control" formControlName="motivo_devolucion" rows="3"></textarea>
            <div *ngIf="devolucionForm.motivo_devolucion.errors"
                 class="invalid-feedback" style="display: block;">
              <div *ngIf="devolucionForm.motivo_devolucion.errors.required">
                Requerido
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-secondary"
            (click)="modal.dismiss('Cross click')">Cerrar
    </button>
    <button class="btn btn-primary mx-1"
            (click)="procesarDevolucion()"
            [ngClass]="{'loading': mostrarSpinner}" [disabled]="mostrarSpinner"
    >
      <span *ngIf="mostrarSpinner" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span>
      Devolver Pedido
    </button>
  </div>
</ng-template>
